import { styled as o, Box as i, Typography as w } from "@mui/material";
import y from "../../assets/icons/icon-footer-logos.png.js";
import l from "../share/apeiron/ApeironLinkButton.js";
import h from "../share/next/Image.js";
import C from "../../config/index.js";
import { EventFooter as $ } from "../../constants/gtm.js";
import L from "../../hooks/analytics/useGoogleTagManager.js";
import "../../../ui-lib/components/ApeironBattleDemoTitle.js";
import "../../../ui-lib/components/ApeironButton.js";
import "../../../ui-lib/components/ApeironCheckbox.js";
import "../../../ui-lib/components/ApeironCounter.js";
import "../../../ui-lib/components/ApeironDivider.js";
import "../../../ui-lib/components/ApeironGotoRoundButton.js";
import "../../../ui-lib/components/ApeironLoadingNow.js";
import "../../../ui-lib/components/ApeironMessagePopup.js";
import "../../../ui-lib/components/ApeironNumberTextField.js";
import "../../../ui-lib/components/ApeironPleaseWait.js";
import "../../../ui-lib/components/ApeironSimpleButton.js";
import "../../../ui-lib/components/ApeironTooltip.js";
import "../../../ui-lib/components/ApeironTooltipInfoButton.js";
import "../../../ui-lib/components/ApeironTooltipSection.js";
import "../../../ui-lib/components/BackButton.js";
import "../../../ui-lib/components/GotoBattlePassEvent.js";
import "../../../ui-lib/components/GotoCheckIn.js";
import "../../../ui-lib/components/GotoGiftCode.js";
import "../../../ui-lib/components/GotoLootRush.js";
import "../../../ui-lib/components/GotoMarketplace.js";
import "../../../ui-lib/components/GotoWebStore.js";
import "../../../ui-lib/components/LoginRequestButton.js";
import "../../../ui-lib/components/MuiCheckbox.js";
import "../../../ui-lib/components/MuiLoading.js";
import "../../../ui-lib/components/Triangle.js";
import { DefaultLinks as v } from "../../../ui-lib/constants/media.js";
import "../../../common-lib/utils/query.js";
import "next/router";
import "ramda";
import { useCallback as c } from "react";
import { useTranslation as T } from "react-i18next";
import { jsxs as m, jsx as t } from "react/jsx-runtime";
const E = o(h)`
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
`, I = o(i)`
  display: flex;
  flex-direction: column;
  z-index: 0;
`, z = o(h)`
  aspect-ratio: 4;

  ${(e) => e.theme.breakpoints.up("res3440")} {
    width: 800px;
  }
  ${(e) => e.theme.breakpoints.between("res1024", "res3440")} {
    width: 400px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    width: 260px;
  }
`, N = o(i)`
  background: #1e313a;
  padding: 30px 20px;
  position: relative;
`, _ = o(w)`
  color: #999;
  margin-top: 10px;

  ${(e) => e.theme.breakpoints.up("res3440")} {
    font-size: 22px;
  }
  ${(e) => e.theme.breakpoints.between("res1024", "res3440")} {
    font-size: 14px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    font-size: 14px;
  }
`, P = o(i)`
  display: flex;
  background: #000;
  flex-direction: column;
  align-items: center;
  padding: 20px 20px 60px 20px;
  gap: 10px;
`, B = o(i)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
  width: 100%;

  ${(e) => e.theme.breakpoints.up("res3440")} {
    gap: 30px;
  }
  ${(e) => e.theme.breakpoints.between("res1024", "res3440")} {
    gap: 20px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    gap: 10px;
  }
`, F = o(l)`
  aspect-ratio: 1;
  border-radius: 8px;

  ${(e) => e.theme.breakpoints.up("res3440")} {
    width: 90px;
  }
  ${(e) => e.theme.breakpoints.between("res1024", "res3440")} {
    width: 60px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    width: 34px;
  }
`, s = o(l)`
  ${(e) => e.theme.breakpoints.up("res3440")} {
    font-size: 22px;
  }
  ${(e) => e.theme.breakpoints.between("res1024", "res3440")} {
    font-size: 14px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    font-size: 14px;
  }
`, a = o(i)`
  height: 100%;
  display: inline-block;
  margin: 0px 14px;
  color: #fff;

  ::before {
    content: '|';
  }
`, we = (e) => {
  const {
    className: d,
    privacyUrl: x,
    termsUrl: f,
    mediaKitUrl: u,
    links: g = v
  } = e, {
    t: n
  } = T(), {
    gtmEmitEvent: p
  } = L(), b = c(() => {
    p($.ToWhitePaper, {});
  }, [p]), k = c((r) => {
    p(r, {});
  }, [p]);
  return /* @__PURE__ */ m(I, {
    className: d,
    children: [/* @__PURE__ */ t(N, {
      className: "Custom-Community-Icons-Container",
      children: /* @__PURE__ */ t(B, {
        children: g.map((r) => /* @__PURE__ */ t(F, {
          onClick: () => {
            k(r.event);
          },
          url: r.href,
          target: "_blank",
          children: /* @__PURE__ */ t(E, {
            src: r.icon
          })
        }, r.event))
      })
    }), /* @__PURE__ */ m(P, {
      className: "Custom-Bottom-Container",
      children: [/* @__PURE__ */ t(z, {
        src: y
      }), /* @__PURE__ */ t(_, {
        children: n("footer.copyright", {
          year: (/* @__PURE__ */ new Date()).getFullYear()
        })
      }), /* @__PURE__ */ m(i, {
        children: [/* @__PURE__ */ t(s, {
          url: x,
          children: n("footer.privacy_policy")
        }), /* @__PURE__ */ t(a, {}), /* @__PURE__ */ t(s, {
          url: f,
          children: n("footer.terms")
        }), /* @__PURE__ */ t(a, {}), /* @__PURE__ */ t(s, {
          url: u,
          children: n("footer.media_kit")
        }), /* @__PURE__ */ t(a, {}), /* @__PURE__ */ t(s, {
          target: "_blank",
          onClick: b,
          url: C.EXTERNAL_URL.WHITEPAPER,
          children: n("footer.whitepaper")
        })]
      })]
    })]
  });
};
export {
  we as default
};
//# sourceMappingURL=Footer.js.map
